import { render, staticRenderFns } from "./FilteredSentence.vue?vue&type=template&id=977eee92"
import script from "./FilteredSentence.vue?vue&type=script&lang=js"
export * from "./FilteredSentence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports